import React, { useEffect } from 'react';
import { Divider, Loader } from '@kl/components-v6';
import { useTrackPageView } from 'features/tracking';
import { useInitialInfo } from 'shared/api/use-initial-info';
import { Footer } from 'shared/ui/footer/Footer';
import { useGetIAMUrls } from '../model/useGetIAMUrls';
import { getContent } from '../model/content';
import { MainBanner } from './main-banner/MainBanner';
import { Promo } from './promo-section/Promo';
import { ContentSection } from './content-section/ContentSection';
import { StyledContentContainer, StyledLandingContainer } from './styled';
import { Header } from './Header';

enum AppType {
    Local = 'LOCAL',
    Cloud = 'CLOUD',
    Xdr = 'XDR',
    Next = 'NEXT',
}
const CACHED_APP_TYPE_LOCAL_STORAGE_KEY = 'CACHED_APP_TYPE';

export const Landing = () => {
    useTrackPageView('landing');
    const { data: iamUrls, isLoading, isError, error } = useGetIAMUrls();
    const { isKscMode, isFetching: isInitialInfoLoading } = useInitialInfo();
    window.localStorage.removeItem('username');

    useEffect(() => {
        if (isInitialInfoLoading) return;
        const appType = isKscMode ? AppType.Cloud : AppType.Next;
        window.updateTitleAndFavicon?.(appType);
        localStorage.setItem(CACHED_APP_TYPE_LOCAL_STORAGE_KEY, appType);
    }, [isKscMode, isInitialInfoLoading]);

    if (isLoading || isInitialInfoLoading) {
        return <Loader centered size="large" />;
    }

    if (!iamUrls || isError) {
        throw error;
    }

    const { signUp, signIn } = iamUrls;

    return (
        <StyledLandingContainer>
            <Header />
            <main>
                <MainBanner isKscMode={isKscMode} signIn={signIn} signUp={signUp} />
                <StyledContentContainer>
                    {getContent(isKscMode).map(section => (
                        <ContentSection key={section.localizationPath} {...section} />
                    ))}
                </StyledContentContainer>
                <Divider />
                <Promo signUp={signUp} />
            </main>
            <Divider />
            <footer>
                <Footer isKscMode={isKscMode} />
            </footer>
        </StyledLandingContainer>
    );
};
